// Stripe configuration and constants
export const STRIPE_CONFIG = {
  prices: {
    professional: {
      monthly: "price_1U3lwGELrUWyxuVLWBfePwDB", // Replace with your actual price ID
      annual: "price_1RNP6kELrUWyxuVLx9kzXcKy", // Replace with your actual price ID
    },
  },
  /**
   * Promotion Code *object id* from Stripe (starts with `promo_`).
   * Billing → Promotion codes → click the code → copy "ID" (not the "Code" customers type).
   */
  welcomePromotionCodeId:
    process.env.REACT_APP_STRIPE_WELCOME_PROMOTION_CODE_ID || "",
  // Replace with your actual URLs from Stripe Dashboard
  checkoutUrl: "https://checkout.stripe.com/c/pay/YOUR_CHECKOUT_URL",
  customerPortalUrl:
    "https://billing.stripe.com/p/login/test_28o14d0vq6Dr5zicMM",
};
